export enum urlParamsEnum {
    TAB = 'tab',
    ORDERS = 'orders',
}
